// File#: _1_video

(function () {

    function appendVideo(e) {
        var videoId = e.currentTarget.dataset.videoid,
            elId = 'video-' + videoId,
            url = "https://www.youtube.com/embed/" + videoId + "?mute=1&modestbranding=1&autohide=1&showinfo=0&autoplay=1&rel=0&enablejsapi=1",
            iframe = '<iframe class="radius-md" id="' + elId + '" src="' + url + '" allowfullscreen></iframe>';

        // Append this iframe to the DOM
        e.currentTarget.innerHTML = iframe;
    }

    function appendVimeoVideo(e) {
        var videoId = e.currentTarget.dataset.videoid,
            elId = 'video-' + videoId,
            url = "https://player.vimeo.com/video/" + videoId + "?h=bcea51a531&autoplay=1&title=0&byline=0&portrait=1&muted=1",
            iframe = '<iframe class="radius-md" id="' + elId + '" src="' + url + '" allowfullscreen></iframe>';

        // Append this iframe to the DOM
        e.currentTarget.innerHTML = iframe;
    }

    function appendUploadedVideo(e) {
        var video = e.currentTarget.nextElementSibling;
        e.currentTarget.remove();
        video.play();
        video.setAttribute("controls", "controls");
        Util.removeClass(video, 'pointer-events-none')
    }

    const videoElements = document.querySelectorAll('.video');
    for (var i = 0; i < videoElements.length; i++) {
        videoElements[i].addEventListener('click', function (event) {
            appendVideo(event);
        });
    }

    const vimeoVideoElements = document.querySelectorAll('.video-vimeo');
    for (var i = 0; i < vimeoVideoElements.length; i++) {
        vimeoVideoElements[i].addEventListener('click', function (event) {
            appendVimeoVideo(event);
        });
    }

    const uploadedVideoElements = document.querySelectorAll('.video-uploaded');
    for (var i = 0; i < uploadedVideoElements.length; i++) {
        uploadedVideoElements[i].addEventListener('click', function (e) {
            appendUploadedVideo(e);
        });
    }
})();